export default __webpack_public_path__ + "static/media/image-product.e88a1cf4.png";